
import './TextCarousel.css'
import React from "react";
import Typewriter from 'typewriter-effect';

function TextCarousel() {
    return (
        <div className="typing-carousel-wrapper">
            <Typewriter
                options={{
                    strings: ["She/Her","Computer Engineering Student", "Test Engineer", "McMaster Baja SAE", "Hackathon Organizer"],
                    autoStart: true,
                    loop: true,
                    delay: 120,
                    deleteSpeed: 80,
                }}
            />
        </div>
    )
}

export default TextCarousel